import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { I18nInterpolateDirective } from '../../../i18n/components/i18n-interpolate.directive';
import { I18nComponent } from '../../../i18n/components/i18n.component';
import { useI18n } from '../../../i18n/services/i18n.service';
import { ConsentMetadata } from '../../model/consent-checkbox';

@Component({
  selector: 'cdf-consent-data',
  imports: [I18nComponent, I18nInterpolateDirective],
  template: `
    @if (metadata(); as metadata) {
      <i18n key="consent.version" [values]="metadata">
        <time *i18nInterpolate="'date'" [dateTime]="metadata.date">{{ i18n.date(metadata.date) }}</time>
      </i18n>
    }

    <ng-content />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsentDataComponent {
  protected readonly i18n = useI18n();
  readonly metadata = input.required<ConsentMetadata | undefined>();
}
